import { Sport } from "../types";

export const createYoutubeSearchUrl = (stepName: string, sport: Sport, positionGroup?: string): string => {
    // Ensure we use "tackle football" explicitly instead of just "Football"
    const sportTerm = sport === 'Football' ? 'tackle football' : sport;
    
    // Include position group in the search query if available
    const positionGroupTerm = positionGroup != 'ALL' && positionGroup != undefined ? `${positionGroup}` : '';
    
    const searchQuery = `coaching ${sportTerm} drill ${stepName.trim()}` + (positionGroupTerm ? ` for ${positionGroupTerm}` : '');
    return `https://www.youtube.com/results?search_query=${encodeURIComponent(searchQuery)}`;
}